import atom from '@tencent/vft-atom';

import config from './config';

export const canGetInstallState = true;

export function ready() {
  return new Promise((resolve) => {
    if (window.TenvideoJSBridge) {
      resolve();
    } else {
      document.addEventListener(
        'onTenvideoJSBridgeReady',
        () => {
          resolve();
        },
        false,
      );
    }
  });
}

export async function getInstallState(conf = config) {
  await ready();
  if (conf.packageUrl.match(/^(tenvideo2|txvideo):\/\//)) {
    return true;
  }
  return new Promise(async (resolve) => {
    const { installed } = await atom.invoke('isInstalled', {
      pkgName: conf.packageName,
      pkgUrl: conf.packageUrl,
    });
    resolve(installed);
  });
}

export async function launch(schemeUrl) {
  await ready();
  location.href = schemeUrl;
  return true;
}

export async function download() {
  throw new Error('in tenvideo');
}

export default {
  canGetInstallState,
  ready,
  getInstallState,
  launch,
  download,
};
